import type { AccountRole, WorkspaceRole } from '@/data/roles'
import type { UserGroupListItem } from '@/modules/user-management/groups/types'

export enum UserStateFilter {
  All = 'all',
  Connected = 'connected',
  Admin = 'admin',
  User = 'user',
}

export enum UserStatus {
  Active = 'ACTIVE',
  Connected = 'CONNECTED',
}

export interface WorkspaceItem {
  id: string
  name: string
  color: string
  totalMembers: number
  role?: WorkspaceRole
}

export interface User {
  id: string
  name: string
  email: string
  avatar: string | null
  accountRole: AccountRole
  lastLoginAt: string
  status: UserStatus
  hasMultipleAccounts: boolean
  canSetAsBot?: boolean
  zendeskUserId?: string
}

export interface AccountUser extends User {
  workspaces: WorkspaceItem[]
  userGroups: UserGroupListItem[]
}

export interface WorkspaceUser extends User {
  workspaceRole: WorkspaceRole
  userGroups: UserGroupListItem[]
}
